import { useV2ListContactsForClientQuery } from "@generated";
import type { Contact } from "../types";

// Lists a client's active contacts, alphabetical by name (the v2 endpoint has
// no sort param, so we sort client-side).
export const useClientContacts = (clientId: string) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListContactsForClientQuery(
      {
        clientId: clientId,
        filter: { active: true },
        page: { size: 100 },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: Contact[] = (data?.data ?? [])
    .map((c) => ({
      id: String(c.id),
      name: c.attributes?.name ?? "",
      title: c.attributes?.title,
      email: c.attributes?.email,
      phone: c.attributes?.phone,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return { rows, error, isLoading, isFetching, refetch };
};

export default useClientContacts;
